// extracted by mini-css-extract-plugin
export default {"wrapper":"TippyModule_wrapper__r9BdP","fadeIn":"TippyModule_fadeIn__yYVCR"};